import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';

import Header from 'components/Dashboard/Header';
import SparkShareModal from '../Share/SparkShareModal';
import SolutionSection from './SolutionSection';
import { usePopover, useResize } from 'hooks/common';
import { SparkButton, SparkMarkdown } from 'sharedComponents/UI';
import { useWelcome } from 'hooks/useWelcome';
import { FacebookIcon, InstagramIcon } from 'components/SVG';

function TempProdScreen() {
  const response = useWelcome();
  const { isMobile } = useResize();
  const {
    anchorEl: sparkShareAnchor,
    open: sparkSharePopoverOpen,
    openPopover: openSparkSharePopover,
    closePopover: closeSparkSharePopover,
  } = usePopover();
  const welcomeAttributes = response.data?.attributes;
  return (
    <Box overflow='hidden'>
      <Header toggleDrawer={() => {}} />
      <Box
        marginTop='4rem'
        width='100%'
        display='flex'
        flexDirection='column'
        alignItems='center'
        minHeight='calc(100vh - 4rem)'
      >
        <Box maxWidth={isMobile ? '90%' : '50%'} marginY={2} flex={1}>
          <Box
            bgcolor='white'
            borderRadius='20px'
            padding={2}
            marginTop={2}
            border={(theme) => `1px solid ${theme.palette.borderColor}`}
            display='flex'
            flexDirection='column'
            gap={2}
          >
            <Typography fontFamily='Mont-semibold'>
              {welcomeAttributes?.welcome.welcomeTitle}
            </Typography>
            <div
              dangerouslySetInnerHTML={{
                __html: welcomeAttributes?.welcome.welcomeText || '',
              }}
            />
            {!!welcomeAttributes?.welcome.videoURL && (
              <Box
                alignSelf='center'
                sx={{
                  position: 'relative',
                  overflow: 'hidden',
                  width: '100%',
                  paddingTop: '56.25%',
                }}
              >
                <iframe
                  width='100%'
                  height='100%'
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                  }}
                  src={welcomeAttributes?.welcome.videoURL}
                  title='YouTube video player'
                  frameBorder='0'
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                  referrerPolicy='strict-origin-when-cross-origin'
                ></iframe>
              </Box>
            )}
          </Box>
          <Box
            bgcolor='white'
            borderRadius='20px'
            padding={2}
            marginTop={2}
            border={(theme) => `1px solid ${theme.palette.borderColor}`}
            display='flex'
            flexDirection='column'
            gap={2}
          >
            <Typography fontFamily='Mont-semibold'>
              {welcomeAttributes?.offer.offerTitle}
            </Typography>

            <div
              dangerouslySetInnerHTML={{
                __html: welcomeAttributes?.offer.offerText || '',
              }}
            />

            <SparkButton
              variant='contained'
              onClick={openSparkSharePopover}
              sx={{ minWidth: '40%', alignSelf: 'center', marginTop: 2 }}
            >
              <Typography noWrap={true}>Invite Friends</Typography>
            </SparkButton>
          </Box>
          {!!welcomeAttributes?.solution && (
            <Box
              bgcolor='white'
              borderRadius='20px'
              padding={2}
              paddingY={3}
              marginTop={2}
              border={(theme) => `1px solid ${theme.palette.borderColor}`}
            >
              {welcomeAttributes?.solution.solutionText ? (
                <Box padding={2} display='flex' flexDirection='column' gap={2}>
                  <SparkMarkdown>
                    {welcomeAttributes?.solution.solutionText}
                  </SparkMarkdown>
                </Box>
              ) : (
                <SolutionSection />
              )}
            </Box>
          )}
        </Box>
        <Box
          width='100%'
          bgcolor='white'
          padding={2}
          maxHeight='2rem'
          marginTop={2}
          border={(theme) => `1px solid ${theme.palette.borderColor}`}
          display='flex'
          justifyContent='center'
          alignItems='center'
        >
          <IconButton
            onClick={() =>
              window.open('https://www.facebook.com/sparkupai?_rdc=1&_rdr')
            }
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            onClick={() => window.open('https://www.instagram.com/sparkup.ai/')}
          >
            <InstagramIcon />
          </IconButton>
        </Box>
      </Box>
      <SparkShareModal
        open={sparkSharePopoverOpen}
        anchorEl={sparkShareAnchor}
        handleClose={closeSparkSharePopover}
        shareLink={welcomeAttributes?.offer.referralLink}
      />
    </Box>
  );
}

export default TempProdScreen;
